
export const VideoCardContent = ({ heading }) => {

    return (
        <div>
            <h4>{heading}</h4>
        </div>
    )
}